import { MapProvider } from './MapPageContext';
import MapScreenContainer from '../../containers/MapScreenContainer';

export default function MapPage() {
  return (
    <MapProvider>
      <MapScreenContainer />
    </MapProvider>
  );
}
